import { useState } from "react";
import { toast } from "sonner";
import { Plus, Trash2, Loader2, Calculator } from "lucide-react";
import { api } from "../../lib/api";

const mxn = (v) => Number(v || 0).toLocaleString("es-MX", { style: "currency", currency: "MXN", maximumFractionDigits: 2 });

export default function ModuleQuote({ moduleKey, item, onRefresh }) {
  const [form, setForm] = useState({ concepto: "", cantidad: 1, precio: "", descuento_pct: 0 });
  const [busy, setBusy] = useState(false);
  const lines = item.lines || [];

  const add = async () => {
    if (!form.concepto.trim()) return toast.error("Escribe un concepto");
    setBusy(true);
    try {
      await api.post(`/mod/${moduleKey}/items/${item.id}/quote/lines`, {
        concepto: form.concepto, cantidad: Number(form.cantidad) || 1,
        precio: Number(form.precio) || 0, descuento_pct: Number(form.descuento_pct) || 0,
      });
      setForm({ concepto: "", cantidad: 1, precio: "", descuento_pct: 0 });
      onRefresh?.();
    } catch (e) { toast.error(e?.response?.data?.detail || "Error"); }
    finally { setBusy(false); }
  };
  const del = async (id) => {
    try { await api.delete(`/mod/${moduleKey}/items/${item.id}/quote/lines/${id}`); onRefresh?.(); }
    catch { toast.error("Error"); }
  };

  const input = "bg-white border border-navy/10 rounded-lg px-2 py-1.5 outline-none focus:border-violet text-sm";
  return (
    <div className="mt-4 border-t border-navy/10 pt-4 space-y-3" data-testid="module-quote">
      <div className="flex items-center gap-2 overline text-navy/40"><Calculator className="w-3.5 h-3.5" /> Partidas y totales</div>

      {lines.length > 0 && (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead><tr className="text-navy/45 text-xs"><th className="text-left font-medium py-1">Concepto</th><th className="text-right font-medium">Cant.</th><th className="text-right font-medium">Precio</th><th className="text-right font-medium">Desc.</th><th className="text-right font-medium">Importe</th><th /></tr></thead>
            <tbody>
              {lines.map((l) => (
                <tr key={l.id} className="border-t border-navy/5" data-testid={`quote-line-${l.id}`}>
                  <td className="py-1.5 text-navy/80">{l.concepto}</td>
                  <td className="text-right text-navy/60">{l.cantidad}</td>
                  <td className="text-right text-navy/60">{mxn(l.precio)}</td>
                  <td className="text-right text-navy/60">{l.descuento_pct || 0}%</td>
                  <td className="text-right text-navy/80">{mxn(l.importe)}</td>
                  <td className="text-right"><button onClick={() => del(l.id)} className="text-navy/25 hover:text-destructive" data-testid={`quote-del-${l.id}`}><Trash2 className="w-3.5 h-3.5" /></button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <div className="grid grid-cols-12 gap-2 items-end">
        <input className={`${input} col-span-5`} placeholder="Concepto" value={form.concepto} onChange={(e) => setForm({ ...form, concepto: e.target.value })} data-testid="quote-concepto" />
        <input className={`${input} col-span-2`} type="number" step="any" placeholder="Cant." value={form.cantidad} onChange={(e) => setForm({ ...form, cantidad: e.target.value })} data-testid="quote-cantidad" />
        <input className={`${input} col-span-2`} type="number" step="any" placeholder="Precio" value={form.precio} onChange={(e) => setForm({ ...form, precio: e.target.value })} data-testid="quote-precio" />
        <input className={`${input} col-span-2`} type="number" step="any" placeholder="% Desc." value={form.descuento_pct} onChange={(e) => setForm({ ...form, descuento_pct: e.target.value })} data-testid="quote-descuento" />
        <button onClick={add} disabled={busy} className="btn btn-primary col-span-1 justify-center px-2" data-testid="quote-add-btn">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Plus className="w-4 h-4" />}</button>
      </div>

      <div className="bg-navy/[0.03] rounded-lg p-3 text-sm space-y-1" data-testid="quote-totals">
        <div className="flex justify-between text-navy/60"><span>Subtotal</span><span>{mxn(item.subtotal)}</span></div>
        <div className="flex justify-between text-navy/60"><span>Descuento</span><span>−{mxn(item.descuento)}</span></div>
        <div className="flex justify-between text-navy/60"><span>IVA (16%)</span><span>{mxn(item.impuesto)}</span></div>
        <div className="flex justify-between font-editorial text-lg text-navy/90 pt-1 border-t border-navy/10"><span>Total</span><span data-testid="quote-total">{mxn(item.total)}</span></div>
      </div>
    </div>
  );
}
